import { SET_STORE_USER } from '../mutation_types'
const state = {
  pathName: '',
  saveCurr: ''
}
const mutations = {
  [SET_STORE_USER] (state, pathName) {
    state.pathName = pathName
  }
}
export default {
  state,
  mutations
}
